import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import { defaultMessages } from '../../../../libs/i18n/default';
/*global google*/

const GoogleMapsAddress = ({ addressValidations, updateAddress, formatMessage, className, countryCode, territory_code, addressNotFound }) => {
  const [searchedAddress, setSearchedAddress] = useState(null)
  const autocompleteRef = useRef()
  const [addressUnit, setAddressUnit] = useState('')
  const [addressStreetNo, setAddressStreetNo] = useState('')
  const [addressStreetName, setAddressStreetName] = useState('')
  const [addressCity, setAddressCity] = useState('');
  const [addressState, setAddressState] = useState('');
  const [addressPostCode, setAddressPostCode] = useState('');

  const updateAddressState = (key, value) => {
    updateAddress(key, value);
  }

  const changeAddressControl = (e) => {
    updateAddressState(e.target.id, e.target.value);
  }

  const keyInAddress = (e) => {
    updateAddressState('place_id', '');
  }

  const placeholderState = () => {
    return territory_code === 'NZ'
      ? defaultMessages.clientHostPagesRegisterPlaceholdersStateNz
      : defaultMessages.clientHostPagesRegisterPlaceholdersState
  }

  const placeholderCity = () => {
    return territory_code === 'NZ'
      ? defaultMessages.clientHostPagesRegisterPlaceholdersCityNz
      : defaultMessages.clientHostPagesRegisterPlaceholdersCity
  }

  const fullAddressForm = () => {
    const addressStateError = addressValidations && addressValidations.state === false
    const addressPostCodeError = addressValidations && addressValidations.postcode === false

    if (!searchedAddress) return null

    return(
      <div className="well well-sm">
        <div className="row">
          <div className="col-sm-6">
            <FormGroup>
              <FormControl id="unit_no"
                type="text"
                componentClass="input"
                className="contains-no-error"
                value={addressUnit}
                placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersUnit)}
                onChange={changeAddressControl} />
            </FormGroup>
          </div>
          <div className="col-sm-6">
            <FormGroup>
              <FormControl id="street_no"
                type="text"
                componentClass="input"
                value={addressStreetNo}
                className="contains-no-error"
                placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersStreetNumber)}
                onChange={changeAddressControl} />
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <FormGroup>
              <FormControl id="street_name"
                value={addressStreetName}
                type="text"
                componentClass="input"
                className="contains-no-error"
                placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersStreet)}
                onChange={changeAddressControl} />
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <FormGroup>
              <FormControl id="city"
                value={addressCity}
                type="text"
                componentClass="input"
                placeholder={formatMessage(placeholderCity())}
                className="contains-no-error"
                onChange={changeAddressControl} />
            </FormGroup>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <FormGroup>
              <FormControl id="state"
                value={addressState}
                type="text"
                componentClass="input"
                placeholder={formatMessage(placeholderState())}
                className={!addressStateError && 'contains-no-error'}
                onChange={changeAddressControl} />
            </FormGroup>
            {addressStateError && (
              <small className="address-field-invalid">
                State is invalid
              </small>
            )}
          </div>
          <div className="col-xs-6">
            <FormGroup>
              <FormControl id="post_code"
                value={addressPostCode}
                type="text"
                componentClass="input"
                placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersPostcode)}
                className={!addressPostCodeError && 'contains-no-error'}
                onChange={changeAddressControl} />
            </FormGroup>
            {addressPostCodeError && (
              <small className="address-field-invalid">
                Postcode is invalid
              </small>
            )}
          </div>
        </div>
      </div>
    );
  }

  useEffect(() => {
    var searchField = document.getElementById('autocomplete')
    var autocomplete = new google.maps.places.Autocomplete(searchField, {componentRestrictions: {country: countryCode}});

    autocomplete.addListener('place_changed', function() {
      var place = autocomplete.getPlace();

      if (place && place.place_id){
        console.log(place);
        setSearchedAddress(place.formatted_address);

        updateAddressState('searchedAddress', place.formatted_address);
        updateAddressState('coordinates', `(${place.geometry.location.lat()}, ${place.geometry.location.lng()})`);
        updateAddressState('place_id', place.place_id);

        var country_codes = place.address_components.filter(x => x.types.includes('country'));
        var post_codes = place.address_components.filter(x => x.types.includes('postal_code'));
        var states = place.address_components.filter(x => x.types.includes('administrative_area_level_1'));
        var suburb = place.address_components.filter(x => x.types.includes('sublocality'));
        var city = place.address_components.filter(x => x.types.includes('locality'));
        var street_number = place.address_components.filter(x => x.types.includes('street_number'));
        var unit_number = place.address_components.filter(x => x.types.includes('subpremise'));
        var route = place.address_components.filter(x => x.types.includes('route'));

        if (typeof(post_codes) != undefined && post_codes.length>0){
          var v = post_codes[0].long_name;
          setAddressPostCode(v);
          updateAddressState('post_code', v);
        }
        if (typeof(country_codes) != undefined && country_codes.length>0){
          var v = country_codes[0].short_name;
          updateAddressState('country_code', v);
        }
        if (typeof(states) != undefined && states.length>0){
          const v = states[0].short_name;
          setAddressState(v);
          updateAddressState('state', v);
        }
        if ((typeof(suburb) != undefined && suburb.length>0) ||
          (typeof(city) != undefined && city.length>0)){
          const v = (suburb[0] || city[0]).short_name;
          setAddressCity(v);
          updateAddressState('city', v);
        }
        if (typeof(street_number) != undefined && street_number.length>0){
          var street_number_2 = street_number[0].short_name;
          if (street_number_2.indexOf('/')>-1){
            var unit_street_number = street_number_2.split('/');
            setAddressUnit(unit_street_number[0]);
            updateAddressState('unit_no', unit_street_number[0]);

            setAddressStreetNo(unit_street_number[1]);
            updateAddressState('street_no', unit_street_number[1]);
          }else if(typeof(unit_number) != undefined && unit_number.length>0 && typeof(street_number) != undefined && street_number.length>0){
            setAddressUnit(unit_number[0].short_name);
            updateAddressState('unit_no', unit_number[0].short_name);

            setAddressStreetNo(street_number[0].short_name);
            updateAddressState('street_no', street_number[0].short_name);
          }else{
            setAddressStreetNo(street_number_2);
            updateAddressState('street_no', street_number_2);
          }
        }
        if (typeof(route) != undefined && route.length>0){
          const v = route[0].short_name;
          setAddressStreetName(v);
          updateAddressState('street_name', v);
        }
      }else{
        addressNotFound();
      }
    });
  }, [])

  return (
    <div className={className}>
      <FormGroup>
        <FormControl
          type="search"
          placeholder={formatMessage(defaultMessages.clientHostPagesRegisterPlaceholdersAddress)}
          ref={autocompleteRef}
          id="autocomplete"
          onChange={keyInAddress}
        />
      </FormGroup>
      {fullAddressForm()}
    </div>
  )

}

export default GoogleMapsAddress;
